import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import LoadingPage from "./LoadingPage";
import PageFive from "./PageFive";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageSix from "./PageSix";
import PageSeven from "./PageSeven";

const PageFour = ({ idJadwalCbt, idKelas, idKelasParalel, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [headerSurvey, SetHeaderSurvey] = useState([]);
    const [surveyKarakter, SetSurveyKarakter] = useState([]);
    const [dataSummary, SetDataSummary] = useState([]);
    const [dataMembudaya, SetDataMembudaya] = useState([]);
    const [dataBaik, SetDataBaik] = useState([]);
    const [dataBerkembang, SetDataBerkembang] = useState([]);
    const [dataTerinternalisasi, SetDataTerinternalisasi] = useState([]);
    const [openPage, setOpenPage] = useState(false);
    const [isRiasec, setisRiasec] = useState(false);
    const [array, setArray] = useState([0, 1, 2, 3, 4, 5]);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_FOUR, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    idKelasParalel: idKelasParalel,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Two", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Four ", responseAPI);
                    console.log("====================================");

                    SetHeaderSurvey(responseAPI.listHeader);
                    SetSurveyKarakter(responseAPI.listSurveyKarakter);
                    SetDataSummary(responseAPI.summary);
                    SetDataMembudaya(responseAPI.summary.membudaya);
                    SetDataBaik(responseAPI.summary.baik);
                    SetDataBerkembang(responseAPI.summary.berkembang);
                    // SetDataTerinternalisasi(responseAPI.summary.terinternalisasi);
                    setisRiasec(responseAPI.isRiasec);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            {/* <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Hasil Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                        </GridInline>

                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div> */}
            <Gap height={20} />
            <div className="section-three">
                <div className="result">
                    <LabelTitle label={"Summary Survei Karakter"} size={20} bolder={700} color={"#212529"} />
                    <Gap height={20} />
                    <div className="rekap-table">
                        <GridInline width={"100%"} textAlign={"center"} backgroundColor={"#E9ECEF"} height={125}>
                            <GridInline width={"15%"} verticalAlign={"middle"} height={0}></GridInline>
                            {headerSurvey.map((item, index) => (
                                <GridInline width={"14%"} verticalAlign={"middle"} height={0}>
                                    <img
                                        src={"/assets/image/pemetaan/" + item.tipe + ".png"}
                                        width={45}
                                        style={{
                                            marginBottom: 5,
                                            marginTop: 5,
                                        }}
                                    />
                                    <LabelTitle label={item.aspek} size={17} bolder={400} color={"#6C757D"} />
                                </GridInline>
                            ))}
                        </GridInline>
                        <GridInline width={"100%"} textAlign={"center"} height={70}>
                            <GridInline width={"15%"} verticalAlign={"middle"} height={0}>
                                <Gap height={10} />
                                Membudaya
                            </GridInline>
                            {headerSurvey.map((head, index) => (
                                <GridInline width={"14%"} verticalAlign={"middle"} height={0}>
                                    {dataMembudaya.map((data, index) =>
                                        data.tipe === head.tipe ? (
                                            <p
                                                style={{
                                                    backgroundColor: "#0466C8",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 2,
                                                    width: "80%",
                                                    fontSize: 16,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "15%",
                                                    marginBottom: 5,
                                                    fontWeight: "bolder",
                                                }}
                                            >
                                                Indeks : {data.indexSkorRiasec}
                                            </p>
                                        ) : (
                                            ""
                                        )
                                    )}
                                </GridInline>
                            ))}
                        </GridInline>
                        <GridInline width={"100%"} textAlign={"center"} backgroundColor={"#E9ECEF"} height={70}>
                            <GridInline width={"15%"} verticalAlign={"middle"} height={0}>
                                <Gap height={10} />
                                Berkembang
                            </GridInline>
                            {headerSurvey.map((head, index) => (
                                <GridInline width={"14%"} verticalAlign={"middle"} height={0}>
                                    {dataBerkembang.map((data, index) =>
                                        data.tipe === head.tipe ? (
                                            <p
                                                style={{
                                                    backgroundColor: "#008000",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 2,
                                                    width: "80%",
                                                    fontSize: 16,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "15%",
                                                    marginBottom: 5,
                                                    fontWeight: "bolder",
                                                }}
                                            >
                                                Indeks : {data.indexSkorRiasec}
                                            </p>
                                        ) : (
                                            ""
                                        )
                                    )}
                                </GridInline>
                            ))}
                        </GridInline>
                        <GridInline width={"100%"} textAlign={"center"} height={70}>
                            <GridInline width={"15%"} verticalAlign={"middle"} height={0}>
                                <Gap height={10} />
                                Perlu Ditingkatkan
                            </GridInline>
                            {headerSurvey.map((head, index) => (
                                <GridInline width={"14%"} verticalAlign={"middle"} height={0}>
                                    {dataBaik.map((data, index) =>
                                        data.tipe === head.tipe ? (
                                            <p
                                                style={{
                                                    backgroundColor: "#FB8500",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 2,
                                                    width: "80%",
                                                    fontSize: 16,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "15%",
                                                    marginBottom: 5,
                                                    fontWeight: "bolder",
                                                }}
                                            >
                                                Indeks : {data.indexSkorRiasec}
                                            </p>
                                        ) : (
                                            ""
                                        )
                                    )}
                                </GridInline>
                            ))}
                        </GridInline>
                        {/* <GridInline width={"100%"} textAlign={"center"} height={70}>
                            <GridInline width={"15%"} verticalAlign={"middle"} height={0}>
                                <Gap height={10} />
                                Belum Terinternalisasi
                            </GridInline>
                            {array.map((item, index) => {
                                return (
                                    <GridInline width={"14%"} verticalAlign={"middle"} height={0}>
                                        {dataTerinternalisasi.length > item && (
                                            <p
                                                style={{
                                                    backgroundColor: "#f44336",
                                                    color: "#fff",
                                                    borderRadius: 10,
                                                    padding: 2,
                                                    width: "80%",
                                                    fontSize: 16,
                                                    marginTop: 5,
                                                    textAlign: "center",
                                                    marginLeft: "15%",
                                                    marginBottom: 5,
                                                    fontWeight: "bolder",
                                                }}
                                            >
                                                Indeks : {dataTerinternalisasi[item].indexSkorRiasec}
                                            </p>
                                        )}
                                    </GridInline>
                                );
                            })}
                        </GridInline> */}
                    </div>
                </div>
                <Gap height={15} />
                <Line color={"#E9ECEF"} height={1} />
            </div>
            <Gap height={140} />
            {/* <Gap height={540} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            {/* </div> */}
            {openPage ? <PageSeven idJadwalCbt={idJadwalCbt} idKelas={idKelas} idKelasParalel={idKelasParalel} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageFour;
